<h2 mat-dialog-title>{{ data.title | i18nextCap }}</h2>
<mat-dialog-content>
  @if (data.noTranslation) {
    <span>{{ data.message }}</span>
  } @else {
    <span>
      {{ data.message | i18nextCap: data.translationData }}
    </span>
  }

  @if (data.redirectMessage && data.redirectHref && data.redirectHrefText) {
    <p class="redirect-text">
      <span>
        {{ data.redirectMessage | i18nextCap }}
      </span>
      <a
        class="btn"
        [routerLink]="[data.redirectHref]"
        (click)="dialogRef.close()"
      >
        {{ data.redirectHrefText | i18nextCap }}
      </a>
    </p>
  }

  <!-- In case of token creation -->
  @if (data.tokenId) {
    <div class="center">
      <!-- <p>{{ data.tokenId }}</p> -->
      <mat-form-field appearance="outline">
        <input
          matInput
          [placeholder]="'tokenValue' | i18nextCap"
          [type]="hidePassword ? 'password' : 'text'"
          required
          [value]="data.tokenId"
        />
        <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{
          hidePassword ? 'visibility_off' : 'visibility'
        }}</mat-icon>
        @if (hidePassword) {
          <mat-hint>{{ 'seeTokenId' | i18nextCap }}</mat-hint>
        }
      </mat-form-field>
      <button mat-icon-button [matTooltip]="'copyToken' | i18nextCap">
        <div class="icon grey-icon" [cdkCopyToClipboard]="data.tokenId">
          <fa-icon [icon]="$any(faClipboard)" size="lg"></fa-icon>
        </div>
      </button>
    </div>
  }
</mat-dialog-content>
<div mat-dialog-actions align="end">
  @if (data.closeModalText) {
    <button
      mat-button
      [color]="data?.closeButtonClass ? 'basic' : 'primary'"
      [ngClass]="data?.closeButtonClass"
      mat-dialog-close
      type="button"
    >
      {{ data.closeModalText | i18nextCap }}
    </button>
  }
  @if (data.actionModalText) {
    <button
      mat-flat-button
      [color]="data?.actionButtonClass ? 'primary' : 'warn'"
      [ngClass]="data?.actionButtonClass"
      [mat-dialog-close]="true"
      cdkFocusInitial
      [attr.data-testid]="'modal-action-button-test'"
      type="button"
    >
      {{ data.actionModalText | i18nextCap }}
    </button>
  }
</div>
